export function setModuleData(data) {
    return {
        type: "SET_MODULE_DATA",
        payload: data
    }
}
